import React from 'react';
import { TeamItem } from './../../../../components/TeamItem';
import './style.scss';

export const MundialGroup = ({ groupName, teams }) => {
  return (
    <div className="mundial-group">
      <span className="mundial-group__group-name">{groupName}</span>
      <div className="mundial-group__teams">
        {teams?.map(team => (
          <TeamItem
            actionTag={'grupos'}
            key={team.id}
            teamInfo={team}
            imageStyles={{ width: 64, height: 64 }}
            containerStyles={{ width: '104px', height: '104px' }}
          />
        ))}
      </div>
    </div>
  );
};
